import {Status} from 'constants/StatusConstants';
import {triggerComputedFieldsUpdate} from 'notebook/integrations/registry/RegistrationActionUtil';
import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {BaseTypedValueType} from 'notebook/tables/typed-values/TypedValueConstants';

export default function resolveStaleComputingCells(
  structuredTable: UnknownStructuredTable,
  entryId: string
): void {
  const bioentityColIdx = structuredTable.columns.findIndex(
    (col) => col.columnType === TableColumnType.EXISTING_BIOENTITY
  );
  if (bioentityColIdx === -1) {
    return;
  }

  const bioentityIds: Array<string> = [];
  for (const row of structuredTable.rows) {
    const hasComputing = row.cells.some(
      (cell) =>
        cell.typedValue?.type === BaseTypedValueType.COMPUTING &&
        cell.typedValue.computedState.status !== Status.FAILED
    );
    if (!hasComputing) {
      continue;
    }
    const cell = row.cells[bioentityColIdx];
    if (cell?.typedValue?.type === BaseTypedValueType.BIOENTITY) {
      const id = cell.typedValue.bioentitySummary?.id;
      if (id) {
        bioentityIds.push(id);
      }
    }
  }

  if (bioentityIds.length > 0) {
    triggerComputedFieldsUpdate({
      entryId,
      provenanceUuid: structuredTable.provenanceUuid,
      bioentityIds,
    });
  }
}
